import script from "./LocalContinuityBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalContinuityBanner.vue?vue&type=script&setup=true&lang=js"

import "./LocalContinuityBanner.vue?vue&type=style&index=0&id=6aaef475&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aaef475"]])

export default __exports__